export default __webpack_public_path__ + "static/pochette.inspirations-43b0efa0f78c1273023229cdce84cb44.jpg";